module.exports = __webpack_public_path__ + "img/other.5e2fc526.svg";